import React from 'react';
import JobsPage from './pages/JobsPage';

function App(){
    return (
        <div className='app'>
            <JobsPage/>
        </div>
    )
}

export default App;